locationForm.$inject = ['$rootScope', 'AppService', '$timeout', '$uibModal']

export default function locationForm($rootScope, AppService, $timeout, $uibModal) {
  var directive = {
    restrict: 'E',
    replace: true,
    scope: {
      location: '=',
      currency: '='
    },
    link: function(scope, elem, attrs) {
      scope.$parent[attrs.property] = this
      this.isPristine = () => scope.locationForm.$pristine

      scope.filePath = $rootScope.filePath
      AppService.getMediaPlacements().then(res => scope.mediaPlacements = res.data)
      AppService.getCountries().then(res => scope.countries = res.data)

      scope.uploadMedias = function(files, placement, invalidFiles) {
        files.forEach((file, index) => {
          scope.uploadedFile = true
          $rootScope.$on('uploadProgress', (event, data) => scope.uploadProgress = data)

          AppService.uploadMedia(file).then(res => {
            var file = res.data

            scope.uploadProgress = 100.0
            $timeout(function() {
              scope.hideAlert('uploadedFile')
            }, 5000)

            if (!scope.location.medias) scope.location.medias = new Array()

            var media, originalMedia
            new Promise((resolve, reject) => {
              if (file.type.includes('video')) {
                AppService.getMediaById(file.attrs.mediaId).then(res => {
                  originalMedia = file
                  media = res.data
                  resolve()
                })
              } else {
                media = file
                resolve()
              }
            }).then(() => {
              var existingLocationToMediasSamePlacement = scope.location.medias.filter(media => media.mediaPlacement.placement.toLowerCase() == placement)
              var mediaPlacement = scope.mediaPlacements.find(mediaPlacement => mediaPlacement.placement.toLowerCase() == placement)
              var newLocationToMediaSamePlacement = {
                order: existingLocationToMediasSamePlacement.length + 1,
                mediaId: file.id,
                mediaPlacementId: mediaPlacement.id,
                media: media,
                mediaPlacement: mediaPlacement
              }
              if (originalMedia) newLocationToMediaSamePlacement.originalMedia = originalMedia
              scope.location.medias.push(newLocationToMediaSamePlacement)
              if (existingLocationToMediasSamePlacement.length === 1 && existingLocationToMediasSamePlacement[0].mediaPlacement.isReplace) {
                var index = scope.location.medias.findIndex(media => media === existingLocationToMediasSamePlacement[0], 1)
                scope.location.medias.splice(index, 1)
                newLocationToMediaSamePlacement.order = newLocationToMediaSamePlacement.order - 1
              }
            })
          })
        })
        invalidFiles.forEach((file, index) => {
          scope.invalidFile = true
          scope.file = file
          $timeout(function() {
            scope.hideAlert('invalidFile')
          }, 5000)
        })
      }
      scope.addSpecification = function() {
        if (!scope.location.specifications) scope.location.specifications = new Array()
        scope.location.specifications.push({
          order: scope.location.specifications.length + 1
        })
      }
      scope.deleteSpecification = function(index) {
        scope.location.specifications.splice(index, 1)
      }
      scope.addCommunication = function() {
        if (!scope.location.communications) scope.location.communications = new Array()
        scope.location.communications.push({
          order: scope.location.communications.length + 1,
          isPublished: true
        })
      }
      scope.deleteCommunication = function(communication) {
        var index = scope.location.communications.indexOf(communication)
        scope.location.communications.splice(index, 1)
      }
      scope.addExternalResource = function() {
        $uibModal.open({
          controller: 'ModalExternalResourceController',
          controllerAs: 'modalExternalResource',
          template: require('../../app/external-resource-modal-new.html')
        }).result.then(externalResource => {
          if (externalResource) {
            scope.location.externalResources.push(externalResource)
          }
        })
      }
      scope.removeMedia = function(media) {
        var index = scope.location.medias.findIndex(media2 => media2.id === media.id)
        scope.location.medias.splice(index, 1)
      }
      scope.hideAlert = function(alert) {
        scope[alert] = false
      }
    },
    template: require('./_form-location.html')
  }

  return directive
}